import RequiresPermission from 'tennders-auth/components/RequiresPermission'

type Permission = string | string[]
type FallbackComponent = JSX.Element

export const withPermissionControl = (
  WrappedComponent,
  requiredPermissions: Permission = [],
  fallbackComponent : FallbackComponent = null
) => (props) => (
  <RequiresPermission requiredPermissions={requiredPermissions} fallbackComponent={fallbackComponent}>
    <WrappedComponent {...props} />
  </RequiresPermission>
)
